import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Title = styled.h2`
  ${Typography.XXXXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 30px;
`;

export const Description = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
  padding-bottom: 30px;
`;

export const DownloadSection = styled.div`
  text-align: center;
  margin: 90px 0;

  ${MediaQuery.M_AND_DOWN} {
    margin: 60px 15px;
  }
`;
